import getDepartureCities from './getDepartureCities';
import setDepartureQuery from './setDepartureQuery';

export default {
  getDepartureCities, // for pre-fetch
  setDepartureQuery,
};
